import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-579d87bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "RPExpressListItem" }
const _hoisted_2 = { class: "RPExpressListItem__header" }
const _hoisted_3 = { class: "RPExpressListItem__buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, "ID: " + _toDisplayString(_ctx.item.id), 1),
      _createElementVNode("p", null, "Дата создания: " + _toDisplayString(_ctx.formatDate(_ctx.item.created_at)), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_the_button, {
        class: "primary text small",
        onClick: _ctx.exportRPKList,
        loading: _ctx.state.is_rpk_loading
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Выгрузить список РПК ")
        ]),
        _: 1
      }, 8, ["onClick", "loading"])
    ])
  ]))
}